import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className='not-found'>
            <h1>404</h1>
            <h3>OPPS!!!!!!!!!!!!!!!</h3>
            <p>Page Not Found</p>
        </div>
    );
};

export default NotFound;